export class ItemsModel {

    code: string;
    description: string;
    units: string;
    requested_units: string;
    delivered_units: number;
    units_1: string;
    units_2: string;
    status: string;
    load_status: number;
    ifd: string;
  
    constructor(
        code,
        description,
        units,
        deliveredunits,
        itemStatus,
        reason,
        requestedUnits
        /*code,
        description,
        units,
        requested_units,
        delivered_units,
        units_1,
        units_2,
        status,
        load_status,
        ifd*/
                ) {
                this.code = code;
                this.description= description;
                this.units = units;
                this.delivered_units = deliveredunits;
                this.status = itemStatus;
                this.ifd = reason;
                this.requested_units = requestedUnits;      
        /*this.code: string;
        this.description: string;
        this.units: string;
        this.requested_units: string;
        this.delivered_units: number;
        this.units_1: string;
        this.units_2: string;
        this.status: string;
        this.load_status: number;
        this.ifd: string;*/
    }

  
  }